<template>
    <div class="columns vh-100 is-vcentered is-mobile">
        <div
            class="column is-12-tablet is-offset-0-tablet is-10-desktop is-offset-1-desktop is-6-fullhd is-offset-3-fullhd">
            <h1 class="is-size-4 is-size-5-mobile has-text-weight-bold m-b-40">Reset your password & sign in</h1>

            <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
                <div class="w-100">
                    <div class="column w-100 px-0 is-8-desktop">
                        <ValidationProvider rules="required|min:8|password:@confirm" v-slot="{ errors,valid }">
                            <b-field
                                :type="{ 'is-default': !isValidate,'is-danger': errors[0], 'is-success': valid }"
                                :message="isValidate ? errors : ''"
                            >
                                <b-input placeholder="Password"
                                         v-model="pw"
                                         type="password"
                                         size="is-medium"
                                         icon="account"
                                         ref="password"
                                         password-reveal>
                                </b-input>
                            </b-field>
                        </ValidationProvider>
                    </div>
                    <div class="column w-100 px-0 is-8-desktop">
                        <ValidationProvider name="confirm" rules="required" v-slot="{ errors,valid }">
                            <b-field
                                :type="{ 'is-default': !isValidate,'is-danger': errors[0], 'is-success': valid }"
                                :message="isValidate ? errors : ''"
                            >
                                <b-input placeholder="Repeat Password"
                                         type="password"
                                         size="is-medium"
                                         icon="account"
                                         v-model="pw1"
                                         password-reveal
                                >
                                </b-input>
                            </b-field>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="columns p-t-30 ">
                    <div class="column is-12 is-12-desktop ">
                        <b-button class="w-100-mobile" @click="submit" type="is-primary">Reset password & sign in</b-button>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>


<script>


import axios from "axios";
import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';

setInteractionMode('eager')


export default {
    name: 'LostpwSiginin',
    components: {
        ValidationProvider, ValidationObserver
    },

    data() {
        return {
            pw: "",
            pw1: "",
            isValidate: true,
        }
    },
    methods: {
        submit() {
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }
                axios.post("/api/change-pw", { 
                    pw: this.pw,
                    key: this.$store.state.auth.keyResetPassword
                }).then(response => {
                        if (response.data.status == "ok") {
                            this.$toast.success("Your password has been changed")
                            this.$router.go("/")
                        } else {
                            this.error("")
                        }
                    })
                    .catch(error => {
                        this.error(error)
                    })
            })
        },
        error() {
            this.$toast.error("There has been an error updating your password")
        }
    },
    mounted() {
        this.$nextTick(() => this.$refs.password.focus())
        if(!this.$store.state.auth.keyResetPassword || this.$store.state.auth.authenticated) this.$router.push("/");
    },
    metaInfo() {
        return {
            title: "Change Password | Pickafund",
            meta: [
                { name: 'description', content:  'Change Password | Pickafund'},
                { property: 'og:title', content: "Change Password | Pickafund"},
                
            ]
        }
    }
}

</script>
